import { CSSProperties } from "react";

export const style: CSSProperties = {
  paddingTop: 0.5,
};
